import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79ccaf3b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=79ccaf3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ccaf3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ccaf3b')) {
      api.createRecord('79ccaf3b', component.options)
    } else {
      api.reload('79ccaf3b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79ccaf3b&scoped=true&", function () {
      api.rerender('79ccaf3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/reward-settlement-detail/index.vue"
export default component.exports